import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

export class IsEnableNurseryPayment extends PrimitiveValueObject<boolean> {
  /**
   * 生成
   * @param value 値
   * @returns 値
   */
  static create(value: boolean): IsEnableNurseryPayment {
    return new IsEnableNurseryPayment(value);
  }
}
